import React from "react";
import PropTypes from "prop-types";
import ModalToBody from "../../../../base/ModalToBody";
import { Trans } from "react-i18next";
import CopyCrewMemberForm from "../../../forms/CopyCrewMemberForm";
import { getPeriods } from "../../../../services/api/periods";
import { copyCrewMember } from "../../../../services/api/crewMembers";
import { ajaxErrorHandler } from "../../../../libs/utils";

class CopyBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      periods: []
    };

    this._hideModal = this._hideModal.bind(this);
    this._showModal = this._showModal.bind(this);
    this._handleCopy = this._handleCopy.bind(this);
  }

  static propTypes = {
    company: PropTypes.object,
    event: PropTypes.object,
    registration: PropTypes.object,
    loadCrewMembers: PropTypes.func,
    admin: PropTypes.bool
  };

  UNSAFE_componentWillMount() {
    if (this.props.event.periods) {
      this.setState({
        periods: this.props.event.periods
      });
    } else {
      getPeriods(this.props.event.id).then(response => {
        this.setState({
          periods: response.data
        });
      });
    }
  }

  _showModal() {
    document.body.classList.add("modal-open");
    this.setState({
      showModal: true
    });
  }

  _hideModal() {
    document.body.classList.remove("modal-open");
    this.setState({
      showModal: false
    });
  }

  _handleCopy(values) {
    copyCrewMember(values)
      .then(response => {
        this._hideModal();
        this.props.loadCrewMembers();
      })
      .catch(ajaxErrorHandler);
  }

  render() {
    const { showModal, periods } = this.state;
    const { company, event, registration, admin } = this.props;

    return [
      <button
        key="button"
        type="button"
        className="m-portlet__nav-link btn btn-accent m-btn m-btn--icon"
        onClick={this._showModal}
      >
        <span>
          <i className="la la-copy" />
          <span>
            <Trans>CopyCrewMemberButton</Trans>
          </span>
        </span>
      </button>,

      <ModalToBody key="modal">
        <div
          className="modal fade show"
          id="m_modal_4"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1039"
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <Trans>CopyCrewMemberTitle</Trans>
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this._hideModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              {showModal && (
                <CopyCrewMemberForm
                  company={company}
                  event={event}
                  registration={registration}
                  periods={periods}
                  close={this._hideModal}
                  visible={showModal}
                  onSubmit={this._handleCopy}
                  admin={admin}
                />
              )}
            </div>
          </div>
        </div>

        <div
          className={"modal-backdrop fade " + (showModal ? " show" : "")}
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1038"
          }}
        />
      </ModalToBody>
    ];
  }
}

export default CopyBtn;
